<div data-cy="subtotal" class="price-breakdown text-black">
  <span class="body--xxs">
    {{ 'configurator.subtotal' | cxTranslate }}
  </span>
  <span class="body--xxs">
    {{ this.subtotalPrice }}
  </span>
</div>

<div data-cy="additional-required-solution-section">
  <div class="additional-required-solution">
    <a
      (click)="$event.preventDefault();openDerivativesModal()"
      class="body--xxs ds-cursor--pointer additional-solution-link"
      data-cy="open-derivatives-modal"
    >
      {{ 'configurator.additionalRequiredSolution' | cxTranslate:{count: supplierAlternativeIdCount} }}
    </a>
    <span class="body--xxs text-black">{{ derivativePrice }}</span>
  </div>
  <dcp-additional-required-solutions-modal
    [orderEntriesOneParent]="orderEntriesOneParent"
    [derivativePrice]="derivativePrice"
    [priceData]="priceData"
    [(isModalOpened)]="isDerivativesModalOpened"
  ></dcp-additional-required-solutions-modal>
</div>
